import { gql } from "@apollo/client";
import {
    CONSOLIDATION_BAG_DETAIL_FIELDS,
    ConsolidationBagDetail
} from "../types/ConsolidationTypes";

export const GET_BAG_DETAIL = gql`
    query GetBagDetail($bagId: ID!) {
        getBagDetail(bagId: $bagId) {
            ...ConsolidationBagDetailFields
        }
    }
    ${CONSOLIDATION_BAG_DETAIL_FIELDS}
`;

export interface GetBagDetailVariables {
    bagId: string;
}

export interface GetBagDetailResponse {
    getBagDetail: ConsolidationBagDetail;
} 